import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { IonicModule } from '@ionic/angular';

import { DropDownComponent } from './drop-down.component';

@NgModule({
  imports: [
    CommonModule,
    IonicModule
  ],
  exports: [
    DropDownComponent
  ],
  declarations: [
    DropDownComponent
  ]
})
export class DropDownModule { }
